import React from "react";
import { useState, useContext } from "react";
import { Link } from 'react-router-dom';

import SearchBar from "./common/SearchBar";
import Loader from './common/Loader';

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';



function Form({form}){

  return(
    <tr className="">
      <td><Link className="" to={`/form_builder/` + form.id}> {form.form_code}</Link></td>
      <td>{form.name}</td>
      <td>{form.catalog_entry}</td>
      <td>{form.year} </td>
      <td>{form.cycle}</td>
      <td>{form.section}</td>
    </tr>
  )
}

function YearForms ({year}) {

  const [loading, setLoading] = useState(true);
  const [forms, setForms] = useState([]);
  const [searchText, setSearchText] = useState('');
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  //console.log(year)
  //alert(year)

  React.useEffect(() => {
    let forms = axios_api.get(api_url + '/forms', {
      headers: {"Authorization": token},
      params: {"year": year}
    });

    forms.then(
      (result) => {
        let apiReturnedForms = result.data;
        setForms(apiReturnedForms);
        setLoading(false);
      },
      (error) => {
        console.log(error)
        setForms([]);
      }
    );
  }, []);


  let rows = [];
  for(let i in forms) {
    if (
      forms[i].form_code.toLowerCase().indexOf(searchText.toLowerCase()) === -1 &&
      forms[i].name.toLowerCase().indexOf(searchText.toLowerCase()) === -1 &&
      forms[i].catalog_entry.toLowerCase().indexOf(searchText.toLowerCase()) === -1
    ) {
      //pass
    } else {
      rows.push(
        <Form
          key={forms[i].id}
          form={forms[i]}  
        />
      );
    }
  }  

  return ( loading ? 
    (
      <Loader/>
    ) : (  
      <div className="ms-5">
        <div className="m-3">
          <SearchBar
            key="SearchBar" 
            searchText={searchText} 
            onSearchtextChange={setSearchText} 
          />
        </div>
        <div className="row m-3">
          <table className="table">
            <thead>
              <tr> 
                <th>код формы</th>
                <th>имя формы</th>
                <th>каталожный номер</th>
                <th>год</th>         
                <th>цикл</th>
                <th>section</th>  
              </tr>
            </thead>
            <tbody>
              {rows} 
            </tbody>
          </table>
        </div>
      </div>
    ) 
  )   
}


export default function FormList() {

  const [formsYears, setFormsYears] = useState([])

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);


  React.useEffect(() => {
    let formsYears = axios_api.get(api_url + '/forms_years', {
      headers: {"Authorization": token},
    });

    formsYears.then(
      (result) => {
        let apiReturnedFormsYears = result.data;
        setFormsYears(apiReturnedFormsYears);
      },
      (error) => {
        console.log(error)
        setFormsYears([]);
      }
    );

  }, []);

  function openYearFolder (i) {
    let newFormsYears = structuredClone(formsYears);
    newFormsYears[i].selected = true;
    setFormsYears(newFormsYears)
  }

  function closeYearFolder (i) {
    let newFormsYears = structuredClone(formsYears);
    newFormsYears[i].selected = false;
    setFormsYears(newFormsYears)
  }

  let formsYearsRows = []
  for(let i in formsYears) {
    if (formsYears[i].selected === true) {
      formsYearsRows.push(
        // Without the `key`, React will fire a key warning. 
        // <React.Fragment></React.Fragment> - из full syntax for <></> shortcut
        <React.Fragment 
          key={formsYears[i].year}
        >
          <div
            className="row mx-3 mt-3 p-2 pt-3 rounded year-hover"
            onClick={() => closeYearFolder(i)}
          >
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-folder-minus me-3" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
                <path d="M11 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5"/>
              </svg>
              {formsYears[i].year}
            </h3>
          </div>
          <YearForms
            year={formsYears[i].year}
          />
        </React.Fragment>  
      )
    } else {
      formsYearsRows.push(
        <div
          key={formsYears[i].year}  
          className="row mx-3 mt-3 p-2 pt-3 rounded year-hover"
          onClick={() => openYearFolder(i)}
        >
          <h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-folder-plus me-3" viewBox="0 0 16 16">
              <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z"/>
              <path d="M13.5 9a.5.5 0 0 1 .5.5V11h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V12h-1.5a.5.5 0 0 1 0-1H13V9.5a.5.5 0 0 1 .5-.5"/>
            </svg>
            {formsYears[i].year}
          </h3>
        </div>

      )
    }  
  }

  return(
    <>
      <div className="row">
        <h3 className="m-3">Формы</h3>
      </div>
      <Link className="lk-button m-3" to={`/form_create`}>Создать форму</Link>
      {formsYearsRows} 
    </>
  );
}
